import React, { useState } from 'react'; 
import './Contact.css';
import { BsLinkedin, BsGithub, BsInstagram } from "react-icons/bs"; 
import mail from '../../assets/images/mail.png'; 
import axios from 'axios';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';

const API_BASE_URL = "https://my-portfolio-backend-2kls.onrender.com";

// Framer Motion variants
const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, ease: "easeInOut" } 
  }
};

const Contact = () => {
  const [name, setName] = useState(""); 
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!name || !email || !msg) {
        toast.error("Please provide all fields");
        return; 
      }

      // 🚀 FULL FIX — clean URL
      const res = await axios.post(
        `${API_BASE_URL}/api/v1/portfolio/sendEmail`,
        { name, email, msg }
      );

      if (res.data.success) {
        toast.success(res.data.message);
        setName(""); 
        setEmail("");
        setMsg("");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log("Axios error:", error);
      toast.error("Something went wrong. Check backend logs.");
    }
  };

  return (
    <>
      <motion.div 
        className="contact" 
        id='contact'
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      > 
        <h2 className='col-12 mt-3 mb-1 text-center text-uppercase'>
          Contact Us
          <hr />
        </h2>

        <div className="card card0 border-0">
          <div className="row">

            {/* LEFT IMAGE */}
            <div className="col-md-6 col-lg-6 col-xk-6 col-sm-12">
              <div className="card1">
                <div className="row border-line">
                  <img 
                    src={mail} 
                    alt="contact mail icon" 
                    className="contact-svg-image" 
                  />
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="col-lg-6 col-md-6">
              <form className="card2 d-flex card border-0 px-4 py-4" onSubmit={handleSubmit}>
                <h6>
                  Contact with 
                  <BsLinkedin
                    color="#0077B5" 
                    size={25}
                    className="ms-2 icon-link"
                    onClick={() => window.open("https://www.linkedin.com/in/ayush-mhaisane-858038304")}
                  />
                  <BsGithub
                    color="#EEEEEE" 
                    size={28}
                    className="ms-2 icon-link"
                    onClick={() => window.open("https://github.com/AyushMhaisane")}
                  />
                  <BsInstagram
                    color="#E1306C" 
                    size={28}
                    className="ms-2 icon-link"
                    onClick={() => window.open("https://www.instagram.com/ayush_mhaisane/")}
                  />
                </h6>
                
                <div className="row px-3">
                  <input 
                    type="text"
                    placeholder='Enter Your Name'
                    className='mb-3'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="row px-3">
                  <input 
                    type="email"
                    placeholder='Enter Your Email Address'
                    className='mb-3'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="row px-3">
                  <textarea 
                    placeholder='Write Your Message'
                    className='mb-3'
                    value={msg}
                    onChange={(e) => setMsg(e.target.value)}
                    required
                  />
                </div>

                <div className="row px-3">
                  <button className='button' type='submit'>
                    Send Message
                  </button>
                </div>

              </form>
            </div>

          </div>
        </div>

      </motion.div>
    </>
  );
};

export default Contact;
